import { createReducer } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import { MarketType } from 'views/History/OrderFilter'
import { HistoryTabType } from 'views/History/Tab'
import {
  clearHistoryAction,
  getClosedOrdersAction,
  getConvertHistoryAction,
  getDepositHistoryAction,
  getTradeHistoryAction,
  getTransferHistoryAction,
  getWithdrawHistoryAction,
  updateHistoryTabAction,
  clearTradeHistoryAction,
  clearOrdersHistoryAction,
} from './actions'
import { HistoryState } from './types'

const initialState: HistoryState = {
  historyTab: HistoryTabType.DashBoard,
  closedOrders: {
    list: [],
    isLastPage: false,
    offsetId: 0,
    query: {
      marketType: MarketType.Spot,
      // range: dayjs().format('YYYYMM'),
      symbol: '',
      offsetId: 0,
      limit: 10,
      direction: '',
    },
  },
  trades: {
    list: [],
    isLastPage: false,
    offsetId: 0,
    query: {
      marketType: MarketType.Spot,
      // marketType: MarketType.Spot,
      // range: dayjs().format('YYYYMM'),
      symbol: '',
      offsetId: 0,
      limit: 10,
      direction: '',
    },
  },
  deposit: {
    pending: false,
    results: [],
    hasMore: false,
    nextOffsetId: 0,
    range: '',
  },
  withdraw: {
    pending: false,
    results: [],
    hasMore: false,
    nextOffsetId: 0,
    range: '',
  },
  transfer: {
    pending: false,
    results: [],
    hasMore: false,
    nextOffsetId: 0,
    range: '',
  },
  convert: {
    pending: false,
    results: [],
    hasMore: false,
    nextOffsetId: 0,
    range: '',
  },
}

export default createReducer<HistoryState>(initialState, (builder) => {
  builder
    .addCase(updateHistoryTabAction, (state, { payload }) => {
      state.historyTab = payload.tab
    })
    .addCase(getClosedOrdersAction.fulfilled, (state, { payload }) => {
      const { list, isLastPage, offsetId, query } = payload
      state.closedOrders.list = list
      state.closedOrders.isLastPage = isLastPage
      state.closedOrders.offsetId = offsetId
      state.closedOrders.query = query
    })
    .addCase(clearOrdersHistoryAction, (state) => {
      state.closedOrders.list = []
      state.closedOrders.isLastPage = false
      state.closedOrders.offsetId = 0
    })
    .addCase(getTradeHistoryAction.fulfilled, (state, { payload }) => {
      const { list, isLastPage, offsetId, query } = payload
      state.trades.list = list
      state.trades.isLastPage = isLastPage
      state.trades.offsetId = offsetId
      state.trades.query = query
    })
    .addCase(clearTradeHistoryAction, (state) => {
      state.trades.list = []
      state.trades.isLastPage = false
      state.trades.offsetId = 0
    })

    .addCase(getDepositHistoryAction.fulfilled, (state, { payload }) => {
      if (payload) {
        state.deposit.results = payload.results
        state.deposit.hasMore = payload.hasMore
        state.deposit.nextOffsetId = payload.nextOffsetId
        state.deposit.range = payload.range
        state.deposit.pending = false
      }
    })
    .addCase(getDepositHistoryAction.pending, (state) => {
      state.deposit.pending = true
    })
    .addCase(getDepositHistoryAction.rejected, (state) => {
      state.deposit.pending = false
    })

    .addCase(getWithdrawHistoryAction.fulfilled, (state, { payload }) => {
      if (payload) {
        state.withdraw.results = payload.results
        state.withdraw.hasMore = payload.hasMore
        state.withdraw.nextOffsetId = payload.nextOffsetId
        state.withdraw.range = payload.range
        state.withdraw.pending = false
      }
    })
    .addCase(getWithdrawHistoryAction.pending, (state) => {
      state.withdraw.pending = true
    })
    .addCase(getWithdrawHistoryAction.rejected, (state) => {
      state.withdraw.pending = false
    })
    .addCase(getTransferHistoryAction.fulfilled, (state, { payload }) => {
      if (payload) {
        state.transfer.results = payload.results
        state.transfer.hasMore = payload.hasMore
        state.transfer.nextOffsetId = payload.nextOffsetId
        state.transfer.range = payload.range
        state.transfer.pending = false
      }
    })
    .addCase(getTransferHistoryAction.pending, (state) => {
      state.transfer.pending = true
    })
    .addCase(getTransferHistoryAction.rejected, (state) => {
      state.transfer.pending = false
    })

    .addCase(clearHistoryAction, (state) => {
      state.deposit.pending = false
      state.deposit.results = []
      state.deposit.nextOffsetId = 0
      state.deposit.hasMore = false
      state.deposit.range = ''

      state.withdraw.pending = false
      state.withdraw.results = []
      state.withdraw.nextOffsetId = 0
      state.withdraw.hasMore = false
      state.withdraw.range = ''

      state.transfer.pending = false
      state.transfer.results = []
      state.transfer.nextOffsetId = 0
      state.transfer.hasMore = false
      state.transfer.range = ''

      state.convert.pending = false
      state.convert.results = []
      state.convert.nextOffsetId = 0
      state.convert.hasMore = false
      state.convert.range = ''
    })
    .addCase(getConvertHistoryAction.fulfilled, (state, { payload }) => {
      if (payload) {
        state.convert.pending = false
        state.convert.results = payload.results
        state.convert.hasMore = payload.hasMore
        state.convert.nextOffsetId = payload.nextOffsetId
        state.convert.range = payload.range
      }
    })
    .addCase(getConvertHistoryAction.pending, (state) => {
      state.convert.pending = true
    })
    .addCase(getConvertHistoryAction.rejected, (state) => {
      state.convert.pending = false
    })
})
